<script setup>
const paymentMethods = [
  { name: 'Visa', icon: '/icons/visa.svg' },
  { name: 'Mastercard', icon: '/icons/mastercard.svg' },
  { name: 'DuitNow QR', icon: '/icons/DuitNow.png' }
];
</script>

<template>
  <div>
    <h3 class="text-lg font-semibold text-warm-800 mb-4">Payment Methods</h3>
    <div class="flex gap-4 items-center">
      <img 
        v-for="method in paymentMethods"
        :key="method.name"
        :src="method.icon"
        :alt="method.name"
        class="h-10 w-auto object-contain"
      />
    </div>
  </div>
</template>